import React from 'react';
import { User, Award, Phone, Mail, Clock, ShieldCheck } from 'lucide-react';
import { siteConfig } from '../../data/site-content';

const InfoBar = () => {
  return (
    <div className="bg-white border-b border-[#E8DDCE] py-3 hidden lg:block">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap justify-between items-center gap-4 text-[13px] text-[#3B352F]/80">
          
          {/* Venstre side: Navn og Titel */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <User size={16} className="text-[#123F13]" />
              <span className="font-semibold text-[#123F13] uppercase tracking-wider">{siteConfig.contact.primaryTitle}</span>
            </div>
            <div className="flex items-center gap-2 border-l border-[#E8DDCE] pl-6">
              <Award size={16} className="text-[#8C2F12]" />
              <span>{siteConfig.contact.titles[1]}</span>
            </div>
          </div>

          {/* Højre side: Kontakt og Tid */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <Mail size={16} className="text-[#123F13]" />
              <a href={`mailto:${siteConfig.contact.email}`} className="hover:text-[#123F13] transition-colors">
                {siteConfig.contact.email}
              </a>
            </div>
            <div className="flex items-center gap-2 border-l border-[#E8DDCE] pl-6">
              <Phone size={16} className="text-[#123F13]" />
              <a href={`tel:${siteConfig.contact.phone.replace(/\s/g, '')}`} className="hover:text-[#123F13] transition-colors">
                {siteConfig.contact.phone}
              </a>
            </div>
            <div className="flex items-center gap-2 border-l border-[#E8DDCE] pl-6">
              <Clock size={16} className="text-[#123F13]" />
              <span>{siteConfig.contact.hours}</span>
            </div>
            <div className="flex items-center gap-2 border-l border-[#E8DDCE] pl-6">
              <ShieldCheck size={16} className="text-[#8C2F12]" />
              <span className="italic">{siteConfig.contact.titles[2]}</span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default InfoBar;
